export default "__VITE_ASSET__e3ce2a9c__"